module.exports = __webpack_public_path__ + "static/img/contact_banner.e029959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/contact_banner.png
// module id = 0Ue7
// module chunks = 0